import { render, staticRenderFns } from "./IzuKaishuuView.vue?vue&type=template&id=08e399a4&scoped=true&"
import script from "./IzuKaishuuView.vue?vue&type=script&lang=js&"
export * from "./IzuKaishuuView.vue?vue&type=script&lang=js&"
import style0 from "./IzuKaishuuView.vue?vue&type=style&index=0&id=08e399a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e399a4",
  null
  
)

export default component.exports